// Traduce el stack de navegación de un torneo recién traído del servidor.
//
// mapToViewModel regenera con genId() los ids de rueda, zona y fecha en cada
// mapeo, así que después de un refresco los ids que guarda `nav` ya no existen y
// la guarda de entidad huérfana sacaría al usuario de la pantalla que está
// mirando. Los _id de Mongo tampoco sirven de ancla: el PUT reemplaza el árbol
// entero y Mongo los regenera en cada guardado.
//
// Lo que sí se mantiene es qué entidad es: se busca por nombre (o por fecha
// calendario) y, si eso no alcanza, por posición en el árbol.

// Busca el equivalente de `entidad` dentro de `candidatas`.
// Primero por clave (única): sobrevive a que la reordenen o inserten otra antes.
// Si la clave no identifica a una sola, cae a la posición original: sobrevive a
// que la renombren. Si tampoco hay nada en esa posición, null (la borraron).
const equivalente = (entidad, viejas, candidatas, clave) => {
  if (!entidad) return null;
  const valor = clave(entidad);
  if (valor) {
    const coincidencias = candidatas.filter((c) => clave(c) === valor);
    if (coincidencias.length === 1) return coincidencias[0];
  }
  const indice = viejas.indexOf(entidad);
  return (indice >= 0 && candidatas[indice]) || null;
};

const porNombre = (e) => e.name || "";
const porFechaCalendario = (f) => f.date || "";

// Devuelve el stack con los ids del torneo nuevo. Se traducen todos los frames,
// no solo el actual, para que el botón "atrás" siga funcionando después.
// Un frame que apunta a algo que ya no existe se deja como está: la guarda de
// huérfanos de torneosPublico lo saca del stack, que es lo que corresponde.
export function reanclarNav(nav, torneoViejo, torneoNuevo) {
  if (!torneoViejo || !torneoNuevo) return nav;

  return nav.map((frame) => {
    if (!frame.roundId) return frame;

    const ruedasViejas = torneoViejo.ruedas || [];
    const ruedasNuevas = torneoNuevo.ruedas || [];
    const ruedaVieja = ruedasViejas.find((r) => r.id === frame.roundId);
    const ruedaNueva = equivalente(ruedaVieja, ruedasViejas, ruedasNuevas, porNombre);
    if (!ruedaNueva) return frame;

    const traducido = { ...frame, roundId: ruedaNueva.id };
    if (!frame.zoneId) return traducido;

    const zonasViejas = (ruedaVieja && ruedaVieja.zones) || [];
    const zonasNuevas = ruedaNueva.zones || [];
    const zonaVieja = zonasViejas.find((z) => z.id === frame.zoneId);
    const zonaNueva = equivalente(zonaVieja, zonasViejas, zonasNuevas, porNombre);
    if (!zonaNueva) return traducido;

    traducido.zoneId = zonaNueva.id;
    if (!frame.dateId) return traducido;

    const fechasViejas = (zonaVieja && zonaVieja.matchDates) || [];
    const fechasNuevas = zonaNueva.matchDates || [];
    const fechaVieja = fechasViejas.find((d) => d.id === frame.dateId);
    const fechaNueva = equivalente(fechaVieja, fechasViejas, fechasNuevas, porFechaCalendario);
    if (fechaNueva) traducido.dateId = fechaNueva.id;

    return traducido;
  });
}
